import Radio from 'backbone.radio';
import NotFoundView from '@/views/not_found_view';

    var globalCh = Radio.channel('global');
    export default function not_found(message) {
        var view = new NotFoundView({
            message: message
        });

        // Show view in app container region
        var container_region = globalCh.request('app_layout').getRegion('container');
        container_region.show(view);
    }

